import React from 'react';

import { colors } from './colors';

// Frozen (sticky) header + first column table styling

/** @deprecated Use <TableBETA /> default styles */
export const frozenTableStyling: React.CSSProperties = {
  borderCollapse: 'separate',
  borderSpacing: 0,
};

/** @deprecated Use <TableBETA /> default styles */
export const frozenHeaderRowStyling: React.CSSProperties = {
  position: 'sticky',
  top: 0,
  zIndex: 2,
};

/** @deprecated Use <TableBETA /> default styles */
export const frozenHeaderCellStyling = (
  isFrozenColumn: boolean,
): React.CSSProperties => {
  return {
    position: isFrozenColumn ? 'sticky' : undefined,
    left: isFrozenColumn ? 0 : undefined,
    borderRight: isFrozenColumn ? '2px solid' : 'none',
    borderRightColor: colors.gray[200],
    zIndex: isFrozenColumn ? 2 : 1,
  };
};

/** @deprecated Use <TableBETA /> default styles */
export const frozenRowCellStyling = (
  isFrozenColumn: boolean,
): React.CSSProperties => {
  return {
    position: isFrozenColumn ? 'sticky' : 'relative',
    left: isFrozenColumn ? 0 : undefined,
    borderRight: isFrozenColumn ? '2px solid' : 'none',
    borderRightColor: colors.gray[200],
    background: 'white',
    zIndex: isFrozenColumn ? 1 : 0,
  };
};

export const frozenMultipleHeaderCellStyling = (
  isFrozenColumn: boolean,
  frozenWidth?: number,
): React.CSSProperties => {
  const leftWidth = frozenWidth || 0;

  return {
    position: isFrozenColumn ? 'sticky' : undefined,
    left: isFrozenColumn ? leftWidth : undefined,
    borderRight: isFrozenColumn ? '2px solid' : 'none',
    borderRightColor: colors.gray[200],
    zIndex: isFrozenColumn ? 2 : 1,
  };
};

export const frozenMultipleRowCellStyling = (
  isFrozenColumn: boolean,
  frozenWidth?: number,
): React.CSSProperties => {
  const leftWidth = frozenWidth || 0;

  return {
    position: isFrozenColumn ? 'sticky' : 'relative',
    left: isFrozenColumn ? leftWidth : undefined,
    borderRight: isFrozenColumn ? '2px solid' : 'none',
    borderRightColor: colors.gray[200],
    background: isFrozenColumn ? 'white' : 'none',
    zIndex: isFrozenColumn ? 1 : 0,
  };
};

/** @deprecated Use <TableBETA /> default styles */
export const tableHeaderStyle = {
  backgroundColor: colors.gray[50],
  color: colors.gray[600],
  fontSize: '1rem',
  fontWeight: 500,
  lineHeight: '1.5rem',
  minWidth: '8rem',
  padding: '1rem',
};

export const popperStyling: React.CSSProperties = {
  alignItems: 'center',
  borderRadius: '0.5rem',
  color: colors.gray[600],
  margin: '0.5rem 0',
  padding: '1.5rem',
  userSelect: 'none',
};
